/**
 * Échelles de libellés d'un effort noté en toutes lettres : par quels mots le répondant dira la
 * peine qu'il a dû se donner — de la facilité, de la force, ou de la simplicité.
 *
 * Le choix ne change ni ce que la question mesure ni le nombre de crans : cinq encadrés, du plus
 * favorable au moins favorable, dont l'élément porte les libellés sous `buttonsTexts`, rangés au nom
 * de l'échelle qui les porte. Les valeurs sont celles du discriminant renvoyé par l'API.
 */
export enum CES_TEXT_REPRESENTATION {
    EASY = 'EASY',
    WEAK = 'WEAK',
    SIMPLE = 'SIMPLE',
}
